
const buttonDefault = {
    controlHeight: 36,
}

export const buttonLite = {
    ...buttonDefault,
}
export const buttonDark = {
    ...buttonDefault,
}